import { Injectable } from "@angular/core";
import { GeneralService } from "../../../services/general.service";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";

@Injectable()
export class UsageMonthlyReportService extends GeneralService {
  static WINDOW_3M = 3;
  static WINDOW_6M = 6;
  static WINDOW_12M = 12;
  static WINDOW_24M = 24;
  static WINDOW_48M = 48;

  static DATA_SOURCE_SD1 = 10;
  static DATA_SOURCE_SD2 = 20;
  static DATA_SOURCE_SD3 = 30;
  static DATA_SOURCE_UD1 = 100;

  constructor(protected http: HttpClient) {
    super(http);
  }

  public getWindowSizeOptions() {
    return [
      { value: UsageMonthlyReportService.WINDOW_3M, label: "3 Months" },
      { value: UsageMonthlyReportService.WINDOW_6M, label: "6 Months" },
      { value: UsageMonthlyReportService.WINDOW_12M, label: "12 Months" },
      { value: UsageMonthlyReportService.WINDOW_24M, label: "24 Months" },
      { value: UsageMonthlyReportService.WINDOW_48M, label: "48 Months" },
    ];
  }

  public getDataSourceOptions(
    allowInventoryManagement = false,
    allowExternalSynchronization = false
  ) {
    const result = [
      {
        value: UsageMonthlyReportService.DATA_SOURCE_SD1,
        label: "Replenishment Data",
      },
    ];
    if (allowInventoryManagement) {
      result.push({
        value: UsageMonthlyReportService.DATA_SOURCE_SD2,
        label: "Consumption Data",
      });
      result.push({
        value: UsageMonthlyReportService.DATA_SOURCE_SD3,
        label: "Receiving Data",
      });
    }
    if (allowExternalSynchronization) {
      result.push({
        value: UsageMonthlyReportService.DATA_SOURCE_UD1,
        label: "External Usage Data",
      });
    }
    return result;
  }

  public getDataSourceChoice(
    currentChoice,
    options: Array<{ value: number; label: string }>
  ) {
    if (
      options.findIndex(
        (option) => Number(option.value) === Number(currentChoice)
      ) === -1
    ) {
      currentChoice = UsageMonthlyReportService.DATA_SOURCE_SD1;
    }
    return currentChoice;
  }

  public getReport(filterParams = {}): Observable<any> {
    const url = `${this.apiUrl}/master-data/usage-monthly-report`;
    return this.http.get(url, { params: filterParams });
  }

  public export(filterParams = {}): Observable<any> {
    const url = `${this.apiUrl}/master-data/usage-monthly-report-export`;
    return this.http.get(url, { params: filterParams });
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/oes/services/usage-monthly-report.service.ts